<h1 mat-dialog-title>{{'newOrder.title' | translate}}</h1>

<div mat-dialog-conten style="margin-top: 40px;">

    <div style="margin-top: 30px;">
        <h3>{{"newOrder.popup.secondStep.whatLens" | translate}}</h3>
        <mat-radio-group [(ngModel)]="lensSectionModeSelect" class="lens-section-mode">
            <mat-radio-button *ngIf="!copy" [value]="LensSectionMode.HECHT_PROPOSAL">{{"newOrder.popup.secondStep.hechtProposal" | translate}}</mat-radio-button>
            <mat-radio-button *ngIf="!copy" [value]="LensSectionMode.TRIAL_LENS">{{"newOrder.popup.secondStep.trialLens" | translate}}</mat-radio-button>
            <mat-radio-button *ngIf="!copy" [value]="LensSectionMode.FINAL_LENS">{{"newOrder.popup.secondStep.finalLens" | translate}}</mat-radio-button>
            <mat-radio-button *ngIf="copy" [value]="LensSectionMode.TRIAL_LENS_COPY">{{"newOrder.popup.secondStep.trialLensCopy" | translate}}</mat-radio-button>
            <mat-radio-button *ngIf="copy" [value]="LensSectionMode.FINAL_LENS_COPY">{{"newOrder.popup.secondStep.finalLensCopy" | translate}}</mat-radio-button>
        </mat-radio-group>
    </div>

    <button mat-flat-button color="primary" class="action-button" (click)="goToNewOrderPage()">{{"common.buttons.next" | translate}}</button>
</div>
